import { Typography } from "@mui/material";

import DateBox from "devextreme-react/date-box";
import { useEffect, useState } from "react";
import { Stack } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import {
  DataGrid,
  FilterRow,
  Paging,
  Scrolling,
  Selection,
} from "devextreme-react/data-grid";
import { setFilter } from "../../../store/reducers/report";
import { getViolationTypeDataFun } from "../../../store/reducers/metaCrud";
import { getVehicleServiceType } from "../../../store/reducers/vehicle";
import moment from "moment";
const FilterBox = (props) => {
  const gridBoxDisplayExpr = (item) => {
    // console.log(item);
    return item ? `${item.name}` : "";
  };

  const violationTypeDataList = useSelector(
    (state) => state.metaCrud.violationTypeData
  );
  const [startDate, setStartDate] = useState(
    moment().startOf("year").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment().subtract(0, "days").format("YYYY-M-D")
  );
  const logedUser = useSelector((state) => state.auth.user);
  const vehicleServiceTypeList = useSelector(
    (state) => state.vehicle.vehicleServiceTypeList
  );
  const [typeDateGridBoxValue, setTypeDateGridBoxValue] = useState(1);
  const [serviceTypeGridBoxValue, setServiceTypeGridBoxValue] = useState("");
  const [isGridBoxOpened, setIsGridBoxOpened] = useState(false);
  const [isGridServiceTypeBoxOpened, setIsGridServiceTypeBoxOpened] =
    useState(false);

  const [serviceTypeData, setServiceTypeData] = useState(null);

  // const [typeDate, setTypeDate] = useState([
  //   {
  //     id: 1,
  //     name: "Үндсэн",
  //   },
  //   { id: 2, name: " Ажилчдын " },
  //   { id: 3, name: "Такси" },
  //   { id: 4, name: "Хүүхдийн" },
  //   { id: 5, name: "Ачаа тээвэр" },
  //   { id: 12, name: "Буухиа" },
  // ]);
  const gridColumns = ["name"];
  const filter = useSelector((state) => state.report.filter);
  const dispatch = useDispatch();

  useEffect(() => {
    if (violationTypeDataList === null) {
      dispatch(getViolationTypeDataFun());
    } else {
      setServiceTypeData(violationTypeDataList);
    }
  }, [violationTypeDataList, dispatch]);
  useEffect(() => {
    if (vehicleServiceTypeList === null) {
      dispatch(
        getVehicleServiceType({
          is_active: 1,
        })
      );
    }
  }, [vehicleServiceTypeList, dispatch]);
  useEffect(() => {
    if (typeDateGridBoxValue === "") {
      setTypeDateGridBoxValue("month");
    }
  }, [typeDateGridBoxValue]);
  const dateFilterFun = (value, type) => {
    if (type == 1) {
      console.log(value);

      dispatch(
        setFilter({
          ...filter,
          start_date: value,
          end_date: endDate,
        })
      );
    } else {
      dispatch(
        setFilter({
          ...filter,
          start_date: startDate,
          end_date: value,
        })
      );
    }
  };

  // console.log(feedBackType);
  const dataCompNameGridRender = () => {
    return (
      <DataGrid
        dataSource={vehicleServiceTypeList}
        columns={gridColumns}
        hoverStateEnabled={true}
        selectedRowKeys={typeDateGridBoxValue}
        onSelectionChanged={(e) => {
          //  console.log(e.selectedRowsData);
          const selValue = e.selectedRowKeys.map((ex) => {
            return ex.id;
          });
          // console.log(selValue);
          setTypeDateGridBoxValue(selValue[0]);
          //  console.log(selValue[0]);
          setIsGridBoxOpened(false);
        }}
        height="100%"
      >
        <Selection mode="single" />
        <Scrolling mode="virtual" />
        <Paging enabled={true} pageSize={10} />
        <FilterRow visible={true} />
      </DataGrid>
    );
  };
  // const dataServiceTypeGridRender = () => {
  //   return (
  //     <DataGrid
  //       dataSource={serviceTypeData}
  //       columns={gridColumns}
  //       hoverStateEnabled={true}
  //       selectedRowKeys={serviceTypeGridBoxValue}
  //       onSelectionChanged={(e) => {
  //         //  console.log(e.selectedRowsData);
  //         const selValue = e.selectedRowKeys.map((ex) => {
  //           return ex.id;
  //         });
  //         // console.log(selValue);
  //         setServiceTypeGridBoxValue(selValue[0]);
  //         //  console.log(selValue[0]);
  //         setIsGridServiceTypeBoxOpened(false);
  //       }}
  //       height="100%"
  //     >
  //       <Selection mode="single" />
  //       <Scrolling mode="virtual" />
  //       <Paging enabled={true} pageSize={10} />
  //       <FilterRow visible={true} />
  //     </DataGrid>
  //   );
  // };
  return (
    <>
      <div style={{ margin: "10px" }} className="caption">
        Шүүлт
      </div>
      <Stack direction={"row"} spacing={2} justifyContent={"space-between"}>
        <Typography>Эхлэх:</Typography>

        <DateBox
          height={30}
          defaultValue={startDate}
          displayFormat="yyyy-M-dd"
          onValueChanged={(e) => {
            setStartDate(e.value);
            dateFilterFun(e.value, 1);
          }}
          type="date"
        />
        <Typography>Дуусах:</Typography>
        <DateBox
          height={30}
          defaultValue={endDate}
          displayFormat="yyyy-M-dd"
          onValueChanged={(e) => {
            // console.log(e.value);
            setEndDate(e.value);
            dateFilterFun(e.value, 2);
          }}
          type="date"
        />
      </Stack>
    </>
  );
};

export default FilterBox;
